import { authPages } from "@app/auth";
import { RegistrationPage } from "@app/registration";
import { AnalyticsPublicPage } from "@app/analytics";
import { Navigate, Route, Routes } from "react-router-dom";

export function UnauthenticatedRoutes() {
    return (
        <Routes>
            <Route path="/auth">
                <Route path="login" element={<authPages.LoginPage />} />
                <Route path="forgot-password" element={<authPages.ForgotPasswordPage />} />
                <Route path="reset-password/:token" element={<authPages.ResetPasswordPage />} />
            </Route>
            <Route path="register/:planId" element={<RegistrationPage />} />
            <Route path="analytics/website/:uuid" element={<AnalyticsPublicPage />} />
            <Route path="*" element={<Navigate replace to="/auth/login" />} />
        </Routes>
    );
}
